import Authenticate from 'lib/Core/Authenticate';
import Notify from 'lib/Utils/Alert';
import { useEffect, useMemo, useRef, useState } from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Spinner from 'react-bootstrap/Spinner';
import NotificationAlert from "react-notification-alert";
import { useHistory, useLocation } from 'react-router';
import {
  Nav,
  NavItem
} from "reactstrap";
import './login.scss';
import LoginLeft from './LoginLeft';

import CryptoJS from 'crypto-js';
const securityGroups = [
  "purchaser"
]

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [otpPath, setOtpPath] = useState('mail');
  const [mfaType,setMfaType] = useState("NONE")
  const [showOption,setShowOption] = useState(false);
  const [buttonLoader,setButtonLoader] = useState(false);
  const [contactFinishModal, setContactFinishModal] = useState(false);
  const[encrypted,setEncryptedPassword] =useState('')
  const [newpass,setNewPass] = useState()
  const history = useHistory();
  const notifyRef = useRef();
  const location = useLocation();
  const { state } = location;
  const pass_key=process.env.REACT_APP_PASS_KEY
  const iv = CryptoJS.lib.WordArray.random(16);
  const checkEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError('Enter a valid Email address');
    }
    else {
      setEmailError(null);
    }
  }

  const checkPassword = () => {
    if (password.trim().length < 4) {
      setPasswordError('Enter a valid password')
    }
    else {
      setPasswordError(null)
    }
  }

  const onHandleChange = (e) => {
    setOtpPath(e.target.value)
    const value = e.target.value;
    if(value === "email"){
      setMfaType("NONE")
    }else if(value === "sms"){
      setMfaType("NONE")

    }else if(value === "totp"){
      setMfaType("AUTHENTICATOR")

    }
  }


  function NotifyInfo(msg) {
    Notify(notifyRef, "info", msg);
  }
  useEffect(() => {

    if (state?.state?.msg) {
      NotifyInfo(state?.state?.msg)
    }
  }, [state?.state?.msg])

  const authCtl = useMemo(() => new Authenticate(securityGroups), [securityGroups]);

  function NotifyWarning(msg) {
    Notify(notifyRef,"danger",msg)
    
  }

  
  // const toggleContactFinishModal = (isCancel = false) => {
  //   if (isCancel) {
  //     NotifyInfo("PhoneNo not verified, Please send us email for receiving OTP");
  //   }
  //   setContactFinishModal(!contactFinishModal);
  // };

  // const handleConfirm = () => {
  //   toggleContactFinishModal();
  //   authCtl.getPhoneNoVerificationCodeFromCognito(email).then((data) => {
  //     if (data.status === 'true') {
  //       sessionStorage.setItem('otpPath', JSON.stringify(otpPath));
  //       history.replace('/purchaser-auth/verify-otp');
  //     } else {
  //        Notify(notifyRef,"danger",data?.errorMessage); 
  //     }
  //   });
  // };
  

  
  const LoginSubmit = () => {
    setButtonLoader(true)
     if (passwordError === null && emailError === null) {
    // Create the cipher for encryption
    const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(pass_key), {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });
    const ivString = CryptoJS.enc.Base64.stringify(iv);
    const encryptedString = encrypted.toString();
    const finalEncryptedPassword = `${ivString}:${encryptedString}`;

      authCtl.login(email, finalEncryptedPassword.trim(),mfaType).then((data) => {
        
        
        if (data.error) {
         NotifyWarning(data?.error)
          setButtonLoader(false)
        }
        else if (data.challengeName === "NEW_PASSWORD_REQUIRED") {
          setButtonLoader(false)
          NotifyWarning("You must provide a new password for your account");
          sessionStorage.setItem("session", JSON.stringify(data?.session));
          sessionStorage.setItem("username", JSON.stringify(email));
          history.replace('/purchaser-auth/change-password')
          // window.location.reload();
        }else if(data.challengeName === "SOFTWARE_TOKEN_MFA" ||  data?.qrCode?.length > 0 ){
         history.replace('/purchaser-auth/purchaser-qr-login');
         localStorage.setItem('QRdata',JSON.stringify(data))
         localStorage.setItem("purchaserSession",JSON.stringify(data?.session))
        }
        else {
         sessionStorage.setItem("accessToken", JSON.stringify(data.accessToken));
          sessionStorage.setItem("password", JSON.stringify(password));
          sessionStorage.setItem("username", JSON.stringify(email));
          const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(pass_key), {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC,
          });
          const ivString = CryptoJS.enc.Base64.stringify(iv);
          const encryptedString = encrypted.toString();
          const finalEncryptedPassword = `${ivString}:${encryptedString}`;

          authCtl.requestMFACode(email, finalEncryptedPassword.trim(), otpPath).then(data => {
            if (data.Success === true) {
              setButtonLoader(false)
              sessionStorage.setItem("otpPath", JSON.stringify(otpPath));
              sessionStorage.setItem("verifyed", JSON.stringify("verifyed"));
              history.replace('/purchaser-auth/verify-otp').then(()=>{
                const otpPath = JSON.parse(sessionStorage.getItem("otpPath"));
              })
              // window.location.reload();
            }
            else{
              setButtonLoader(false)
         
            }
          }).catch((error) => {
            console.log("error",error);
            setButtonLoader(false)
            // setButtonDisabled(false)
            NotifyWarning(error);
            if (error == "Can't send otp, user previous OTP or please try again later") {
              history.replace('/purchaser-auth/verify-otp')
              sessionStorage.setItem("otpPath", JSON.stringify(otpPath));
              // window.location.reload();
            }
          });

        }


      }).catch((error) => {
        NotifyWarning(error)
        setButtonLoader(false)
      });

    }
    else {
      setButtonLoader(false);
      checkEmail();
      checkPassword();
    }
  }

  // useEffect(() => {
  //   const handleKeyPress = (event) => {
  //     if (event.key === 'Enter') {
  //       if (passwordError === null && emailError === null) {
  //         LoginSubmit()
  //       }
  //       else {
  //         checkEmail();
  //         checkPassword();
  //       }
  //     }
  //   };

  //   document.addEventListener('keydown', handleKeyPress);
  //   return () => {
  //     document.removeEventListener('keydown', handleKeyPress);
  //   };
  // }, [passwordError, emailError]);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (passwordError === null && emailError === null) {
        LoginSubmit()
      }
      else {
        checkEmail();
        checkPassword();
      }
    }
  };

 

  return (
    <>
    <div className='authPage'>
      <NotificationAlert ref={notifyRef} />
      <div className="wrap">
        <div className="row g-0">
          <div className="col-lg-5">
            <LoginLeft hideCursor={false}/>
          </div>

          <div className="col-lg-7">
            <div className=' h-100 d-flex position-relative  align-items-center justify-content-center j_new_login_page_height w-100'>
              <div className="row w-100">
                <div className="col-xl-6 j_login_side_border">
                  <div className="authRight j_authRight px-2" >
                    <div className='authRightContent provide_credentials  '>
                      <img src="../../assets/img/ncentiva.png" alt="" className='mb-3 d-block d-lg-none' />
                      <h3 className="text-center text-sm-left" style={{ fontSize: '28px' }}>Provide your credentials</h3>
                      <div className="formField">
                        <label htmlFor="">Email</label>
                        <InputGroup className="mb-3">
                          <InputGroup.Text id="basic-addon1"><i className='bx bxs-envelope'></i></InputGroup.Text>
                          <Form.Control
                            placeholder="Enter your email"
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            type='email'
                            // value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyUp={checkEmail}
                            className={emailError && 'border-danger'}
                          />
                        </InputGroup>
                        {emailError && <p className='text-danger mb-2' style={{ marginTop: '-10px', paddingLeft: '40px' }}>{emailError}</p>}
                      </div>
                      <div className="formField">
                        <label htmlFor="">Password</label>
                        <div className="position-relative">
                          <div>
                            <InputGroup className="mb-3">
                              <InputGroup.Text id="basic-addon2"><i className='bx bxs-lock' ></i></InputGroup.Text>
                              <Form.Control
                                placeholder="Enter your password"
                                aria-label="password"
                                aria-describedby="basic-addon2"
                                type={showPassword ? 'text' : 'password'}
                                className={`pe-5 ${passwordError && 'border-danger'}`}
                                // value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                onKeyUp={checkPassword}
                                onKeyPress={handleKeyPress}
                              />
                            </InputGroup>
                          </div>
                          <button className='btn-pass position-absolute end-0 top-0 text-primary h-100 px-3 bg-transparent border-0' onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                          </button>
                        </div>

                        {passwordError && <p className='text-danger mb-2' style={{ marginTop: '-10px', paddingLeft: '40px' }}>{passwordError}</p>}
                      </div>
                      <a href="/purchaser-auth/forgot-password">Forgot password?</a>
                       {
                        buttonLoader ? <button className='btn btn-primaryTwo w-100 mt-4' onClick={LoginSubmit} disabled>
                          <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      /></button>
                      :
                      <button className='btn btn-primaryTwo w-100 mt-4' onClick={LoginSubmit}>Login</button>
                       }
                      
                    </div>
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className='footer_bottom h-100 d-flex align-items-center justify-content-center justify-content-xl-start pb-5 '>
                    <div className='j_login_right_text_box pb-xl-5 px-3'>
                      <h4 className="text-center text-sm-left " style={{ fontSize: '20px' }} >One time password verification.
                      </h4>
                      <p className="text-center text-sm-left" style={{
                        color: '#000',
                        fontWeight: '500',
                        fontSize: '14px'
                      }} >
                        We will send an OTP code to your email.. <br />
                        Please use it before it expires within 5 minutes.
                      </p>
                      
                      <div>
                        <p className="text-center text-sm-left mb-1 mt-4" style={{
                          color: '#000',
                          fontWeight: '500',
                          fontSize: '16px',
                          cursor:"pointer",
                          marginTop:"30px"
                        }} onClick={()=>setShowOption(!showOption)} >Use another method <i class="fas fa-sort-down fs-4"></i></p>
                        {showOption ? 
                        <div className=' d-flex align-items-center justify-content-center justify-content-sm-start'>
                          <div className=' d-flex align-items-center' style={{
                            color: '#000',
                            fontWeight: '500',
                            fontSize: '14px'
                          }}>
                            <div className='me-3'>
                              <input type="radio" value={"mail"} name="radio1" id="radio1" defaultChecked={otpPath}  checked={otpPath === "mail"}  onChange={onHandleChange} />
                              <label htmlFor="radio1" className='mb-0 ms-2'>Email</label>
                            </div>

                            <div className='me-3'>
                              <input type="radio" value={"sms"} name="radio2" id="radio2" checked={otpPath === "sms"}  onChange={onHandleChange} />
                              <label htmlFor="radio2" className='mb-0 ms-2'>SMS</label>
                            </div>
                            {/* <div>
                              <input type="radio" value={"totp"} name="radio3" id="radio3" checked={otpPath === "totp"}  onChange={onHandleChange} />
                              <label htmlFor="radio2" className='mb-0 ms-2'>TOTP</label>
                            </div> */}
                          </div>
                        </div>
                        :""}
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
              <div style={{position:"absolute",left:"0px", bottom:"60px",width:"100%"}} class="footer_auth">
               <div  className=" d-flex justify-content-between align-items-center">
               <Nav>
                <NavItem>
                <div className="copyright text-center" style={{fontSize:"18px",fontWeight:"500"}} >
                © {new Date().getFullYear()}{" "}
              </div>
                </NavItem>
                
              </Nav>
              <p className='mb-0'>
                  <a href="https://docs.ncentiva.com" target="_blank" className="" style={{color:"black",fontSize:"18px",fontWeight:"500"}} >
                    API Documentation
                  </a>
                </p>
               </div>
              
            
            </div>
            </div>
          </div>
          
        </div>
      </div>
      </div>
    {/* <Modal
        isOpen={contactFinishModal}
        toggle={toggleContactFinishModal}
        backdrop="static"
        centered
      >
        <ModalHeader className="bg-warning" toggle={toggleContactFinishModal}>
          Confirm Phone Number Verification
        </ModalHeader>
        <ModalBody>
          <p style={{ fontSize: '22px', fontWeight: '600' }}>
            Do you want to verify your PhoneNo?
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={()=>toggleContactFinishModal(true)}>
            Close
          </Button>
          <Button color="primary" onClick={handleConfirm}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal> */}

    </>
  )
}

export default Login;